import * as React from 'react';
import NavMenu from './NavMenu';
import { AuthStateContext } from '../Services/AuthContext';
import {  Container } from 'reactstrap'
import { useState } from 'react';
import { useEffect } from 'react';
import { HeightProvider } from '../Services/HeightContext';
import { useRef } from 'react';
import useWindowDimensions from '../utils/measureDomNode'

const Layout = ({  children }) => {
    const navRef = useRef();
    const [bodyHeight, setbodyHeight] = useState(); 
    const navHeight = navRef.current?.clientHeight;
    const { height } = useWindowDimensions();

    useEffect(() => {
        if (navRef.current) {
            const newHeight = height - (navRef.current.clientHeight + 15);
            if (newHeight !== 0 && bodyHeight !== newHeight) {
                setbodyHeight(newHeight);
            }
        }
    }, [navHeight,height,bodyHeight]);
    
    return height?<div>
        
            <AuthStateContext.Consumer>
                {
                    value => {

                        const [user] = value ? value : [null];
                        if (user && user.jwt && user.terms) {

                            return (<div >
                                <div ref={navRef}>
                                <NavMenu />
                                </div>
                                <Container style={{ height: bodyHeight }}>
                                    <HeightProvider height={bodyHeight}>
                                        {children}
                                    </HeightProvider>
                                    </Container>
                                </div>)
                       
                        }
                        else return <React.Fragment>
                                {children}
                              
                        </React.Fragment>
                    }
                }
                </AuthStateContext.Consumer>
        
        </div >: null
   

};

export default Layout; 
